import { useAppSelector } from '../../../../hooks/useAppSelector';
import * as clientSlice from '../../../../data/client.slice';
import * as accountingSlice from '../../../../data/accounting.slice';
import ClientPricing from '../ClientPricing';

interface ClientPricingTabProps {
  clientBC: string;
}

export default function ClientPricingTab({ clientBC }: ClientPricingTabProps) {
  const servicePlanList = useAppSelector(clientSlice.selectServicePlanList);
  const pricingModels = useAppSelector(
    accountingSlice.selectActivePricingModels,
  );

  return (
    <ClientPricing
      clientBC={clientBC}
      servicePlans={servicePlanList?.servicePlans || []}
      pricingModels={pricingModels}
    />
  );
}
